export default __webpack_public_path__ + "static/media/349.f91a659b.png";